var map = {
	"./img1_tablet@2x.png": 1776,
	"./img2_tablet@2x.png": 6275,
	"./img3_tablet@2x.png": 7954,
	"./img4_tablet@2x.png": 901,
	"./img5_tablet@2x.png": 5628
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3475;